import React from 'react';
import { Section } from './ui/Section';
import { Clock, BatteryWarning, BrainCircuit } from 'lucide-react';
export function PainNarrative() {
  return <div className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-74">
      <div className="max-w-3xl mx-auto space-y-16" data-id="element-75">
        {/* The Scenario */}
        <Section className="prose prose-lg prose-stone mx-auto" data-id="element-76">
          <p className="text-xl leading-relaxed text-stone-600" data-id="element-77">
            Y lo más frustrante es que no pasa cuando estás "tranquila". Pasa
            cuando ya diste demasiado. Cuando ya resolviste problemas. Cuando ya
            contestaste mensajes. Cuando ya hiciste de todo por todos.
          </p>
          <p className="text-xl leading-relaxed text-stone-600" data-id="element-78">
            Ahí aparece. Ese momento de la tarde —o de la noche— en que tu
            cerebro empieza a negociar contigo como si fueras otra persona:
          </p>

          <div className="bg-[#FFF5F0] p-8 rounded-2xl my-8 border-l-4 border-rose-300" data-id="element-79">
            <ul className="space-y-3 text-lg font-medium text-stone-700 italic list-none pl-0" data-id="element-80">
              <li data-id="element-81">"Solo un poquito."</li>
              <li data-id="element-82">"Te lo mereces."</li>
              <li data-id="element-83">"Hoy fue pesado."</li>
              <li data-id="element-84">"Total, ya mañana vuelvo."</li>
            </ul>
          </div>

          <p className="text-xl leading-relaxed text-stone-600" data-id="element-85">
            Y a veces resistes. Pero quedas tensa, irritable. Y otras veces, no.
            Otras veces comes. Y no es "porque sí". Es porque hay una parte tuya
            que quiere apagar el ruido.
          </p>
        </Section>

        {/* The Cycle */}
        <Section className="bg-stone-50 rounded-3xl p-8 md:p-12" data-id="element-86">
          <h3 className="text-2xl font-serif text-stone-900 mb-8 text-center" data-id="element-87">
            El ciclo invisible que nadie publica en historias
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-88">
            <div className="text-center space-y-4" data-id="element-89">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mx-auto text-rose-600" data-id="element-90">
                <Clock size={24} data-id="element-91" />
              </div>
              <h4 className="font-bold text-stone-800" data-id="element-92">1. La Urgencia</h4>
              <p className="text-sm text-stone-600" data-id="element-93">
                Buscas algo rápido para calmarte. Funciona... por unos minutos.
              </p>
            </div>

            <div className="text-center space-y-4" data-id="element-94">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mx-auto text-rose-600" data-id="element-95">
                <BatteryWarning size={24} data-id="element-96" />
              </div>
              <h4 className="font-bold text-stone-800" data-id="element-97">2. La Culpa</h4>
              <p className="text-sm text-stone-600" data-id="element-98">
                "¿Qué me pasa?", "No puedes ni con esto". La autocrítica te
                drena.
              </p>
            </div>

            <div className="text-center space-y-4" data-id="element-99">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mx-auto text-rose-600" data-id="element-100">
                <BrainCircuit size={24} data-id="element-101" />
              </div>
              <h4 className="font-bold text-stone-800" data-id="element-102">3. La Identidad</h4>
              <p className="text-sm text-stone-600" data-id="element-103">
                Empiezas a creer que "no tienes control", cuando en realidad tu
                sistema está saturado.
              </p>
            </div>
          </div>
        </Section>

        {/* The Truth */}
        <Section data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-serif text-stone-900 text-center mb-8" data-id="element-105">
            Lo que nadie te explicó: <br data-id="element-106" />
            <span className="text-rose-600 italic" data-id="element-107">
              tus antojos no son capricho. Son un sistema.
            </span>
          </h2>

          <div className="prose prose-lg prose-stone mx-auto text-stone-600" data-id="element-108">
            <p data-id="element-109">
              Tú no tienes "un problema de dulces". Tú tienes un sistema
              saturado. Un sistema que viene de dormir menos de lo que
              necesitas, vivir con el estrés encendido, y ser responsable de lo
              invisible.
            </p>
            <p data-id="element-110">
              Y tu cuerpo, cuando vive en estrés, hace algo muy humano:{' '}
              <strong data-id="element-111">Busca energía rápida. Busca calma rápida.</strong>
            </p>
            <p data-id="element-112">
              El azúcar y las harinas son expertas en eso. No porque seas débil.
              Sino porque están diseñadas para eso.
            </p>
          </div>
        </Section>
      </div>
    </div>;
}